

































import Vue from 'vue'
import UserCount from '@/components/Billing/Payment/UserCount.vue'
import TotalPrice from '@/components/Billing/Payment/TotalPrice.vue'
import CalculatedPrice from '@/components/Billing/Payment/CalculatedPrice.vue'
import PayPeriod from '@/components/Billing/Payment/PayPeriod.vue'
import PayMethod from '@/components/Billing/Payment/PayMethod.vue'
import ImgBlock from '@/components/Billing/ImgBlock.vue'
import { ETariffName, CalculatePayload, ModalParams } from '@/models/billing'
import { Company } from '@/models/companies'
import store from '@/store'
import { mapGetters } from 'vuex'
import { ProductsActionTypes } from '@/store/modules/products/actions'
import Close from '@/assets/svg/rounded/close.svg?inline'

interface Props {
  modalSetting: ModalParams
}

interface Data {
  tariffsName: { [key in ETariffName]: ETariffName }
  subscriptionSettings: CalculatePayload
  disableBtn: boolean
  mode: string
}

interface Methods {
  calculate: () => void
  goToPayment: () => void
}

interface Computed {
  calculated: CalculatePayload
  paymentLink: string
  getActiveCompany: Company
  usersMin: number
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    UserCount,
    PayPeriod,
    PayMethod,
    TotalPrice,
    CalculatedPrice,
    ImgBlock,
    Close,
  },
  props: {
    modalSetting: {
      required: true,
    },
  },
  data() {
    return {
      tariffsName: ETariffName,
      subscriptionSettings: {
        users: 1,
        months: 1,
        upgrade: false,
      },
      disableBtn: true,
      mode: 'tinkoff',
    }
  },
  methods: {
    async calculate() {
      this.disableBtn = true
      await store.dispatch(ProductsActionTypes.CalculateSubscription, {
        ...this.subscriptionSettings,
        users: this.modalSetting.enableUsers
          ? this.subscriptionSettings.users
          : 0,
        months: this.modalSetting.enableMonths
          ? this.subscriptionSettings.months
          : 0,
      })
      if (
        this.subscriptionSettings.users > 0 ||
        this.subscriptionSettings.months > 0
      ) {
        this.disableBtn = false
      }
    },
    async goToPayment() {
      await store.dispatch(ProductsActionTypes.BuySubscription, {
        ...this.subscriptionSettings,
        mode: this.mode,
        users: this.modalSetting.enableUsers
          ? this.subscriptionSettings.users
          : 0,
        months: this.modalSetting.enableMonths
          ? this.subscriptionSettings.months
          : 0,
      })
      window.open(this.paymentLink)
    },
  },
  computed: {
    ...mapGetters({
      calculated: 'getCalculate',
      paymentLink: 'getPaymentLink',
      getActiveCompany: 'getActiveCompany',
    }),
    usersMin() {
      if (this.modalSetting.enableUsers) {
        return 1
      }
      return 1
    },
  },
  mounted() {
    this.subscriptionSettings.upgrade = this.getActiveCompany.subscription
    if (this.getActiveCompany.subscription) {
      this.subscriptionSettings.users = this.modalSetting.userCount
    }
    this.calculate()
  },
  watch: {
    'getActiveCompany.subscription'() {
      this.subscriptionSettings = {
        users: 1,
        months: this.getActiveCompany.subscription ? 0 : 1,
        upgrade: this.getActiveCompany.subscription,
      }
    },
  },
})
